import React, { Fragment } from "react";

// Stylesheets
import "./RequestColorDropdown.scss";

// External Components
import Dropdown from "react-bootstrap/Dropdown";

// Icons
import ArrowDown from "../../../assets/icons/arrows/chevron-down.svg";

// Internal Utilities
import { convertToString } from "../../../helper";

function RequestColorDropdown({
  currentSelectedValue = {},
  onChange = () => console.log("Onchange handler is not provided"),
  templateColors = [],
}) {
  const dropdownBtn = React.forwardRef(({ onClick }, ref) => (
    <div
      className="request-dropdown"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <div className="dropdown-container">
        <div className="color-info">
          {convertToString(currentSelectedValue.label) !== "" && (
            <div
              className="color-circle"
              style={{ backgroundColor: currentSelectedValue.colorCode }}
            ></div>
          )}
          <div className="color-name">
            {convertToString(currentSelectedValue.label) === ""
              ? "Select color code"
              : currentSelectedValue.label}
          </div>
        </div>
        <img className="dropdown-icon" src={ArrowDown} alt="down" />
      </div>
    </div>
  ));
  return (
    <Dropdown>
      <Dropdown.Toggle as={dropdownBtn} id="dropdown-basic">
        Dropdown Button
      </Dropdown.Toggle>

      <Dropdown.Menu className="request-dropdown-option">
        {templateColors.map((templateColor, index) => {
          return (
            <Fragment>
              <Dropdown.Item
                as="a"
                style={{
                  width: "100%",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                }}
                onClick={() => onChange(templateColor)}
              >
                <div className="color-code-item  py-2">
                  <div
                    className="color-circle"
                    style={{ backgroundColor: templateColor.colorCode }}
                  ></div>
                  {templateColor.label}
                </div>
              </Dropdown.Item>
              {templateColors.length - 1 !== index && <Dropdown.Divider />}
            </Fragment>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default RequestColorDropdown;
